import React, { useEffect, useState, useCallback } from "react";
import Slider from "react-slick";
import { _slideshow } from "../../constants/slideshows";

function Slideshow() {
  const [slideshows, setSlideshows] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const isMobile = screenWidth < 768;

  // Function to update screenWidth on window resize
  const handleResize = useCallback(() => {
    setScreenWidth(window.innerWidth);
  }, []);

  // Add resize event listener
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  // Load slides data once
  useEffect(() => {
    setSlideshows(_slideshow);
  }, []);

  // Determine if we are in the "tablet" range (between 768 and 1200)
  const isTablet = screenWidth >= 768 && screenWidth < 1200;

  // Calculate ratio padding based on isMobile state
  const ratioPadding = isMobile || isTablet ? "70%" : "50%";

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: isMobile || isTablet ? 1 : 1.7,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    dotsClass: "slick-dots custom-dots",
    appendDots: dots => (
      <ul
        key={currentSlide}
        style={{
          margin: 0,
          padding: 0,
          position: "absolute",
          bottom: "-40px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          listStyle: "none",
        }}
      >
        {dots}
      </ul>
    ),
    customPaging: i => {
      const isActive = i === currentSlide;
      return (
        <div
          style={{
            width: "15px",
            height: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            style={{
              width: isActive ? "15px" : "10px",
              height: isActive ? "15px" : "10px",
              border: "1px solid black",
              borderRadius: "50%",
              backgroundColor: isActive ? "transparent" : "black",
              transition: "all 0.3s ease",
            }}
          ></span>
        </div>
      );
    },
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section
      className="overflow-hidden"
      style={{ position: "relative", paddingBottom: "60px" }}
    >
      <div className="slider-container">
        {/* 
          Using a key that depends on isMobile forces the slider 
          to remount when the breakpoint is crossed.
        */}
        <Slider key={isMobile ? "mobile" : "desktop"} {...settings}>
          {slideshows.map((slide, index) => {
            const className = (index === 0 ? "h1" : "h2") + " fs-30 fs-lg-60 mb-7 fadeInUp animated" + " d-none d-sm-block "
            const titleColor = slide.title_color
            return (
              <div
                key={index}
                className="box px-xl-8"
              >
                <div
                  className="card border-0 text-right"
                  style={{ position: "relative", width: "100%" }}
                >
                  {/* Ratio container */}
                  <div
                    style={{ paddingTop: ratioPadding, position: "relative" }}
                  >
                    <img
                      src={slide.image_url}
                      alt={slide.title}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>

                  {
                    isMobile ?
                      (
                        <div
                          className="card-img-overlay d-flex flex-column justify-content-center p-lg-11"
                          style={{
                            paddingTop : "60px",
                            paddingRight : "60px"
                          }}
                        >
                          <h2 class="fs-30 fs-lg-60 mb-7 fadeInUp animated" data-animate="fadeInUp">
                            {slide.title}
                          </h2>
                          <div
                            data-animate="fadeInUp"
                            className="d-sm-block fadeInUp animated"
                          >
                            <a
                              href={slide.show_link}
                              className="btn btn-outline-primary text-uppercase letter-spacing-05"
                            >
                              Jetzt einkaufen
                            </a>
                          </div>
                        </div>
                      )
                      :
                      (
                        <div
                          className="card-img-overlay d-flex flex-column justify-content-center p-lg-11"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                          }}
                        >
                          <p
                            className={className}
                            data-animate="fadeInUp"
                            style={{ color: titleColor }}
                          >
                            {slide.title}
                          </p>
                          <div
                            data-animate="fadeInUp"
                            className="d-none d-sm-block fadeInUp animated"
                          >
                            <a
                              href={slide.show_link}
                              className="btn btn-outline-primary text-uppercase letter-spacing-05"
                            >
                              Jetzt einkaufen
                            </a>
                          </div>
                        </div>
                      )
                  }
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </section>
  );
}

export default Slideshow;